import { use } from 'react';
import { useTranslation } from 'react-i18next';
import { TableOverflowMenuItem } from 'shared/components/table/hooks';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import type { Tenant } from 'features/tenants/models/tenant';
import TenantsProviderContext from 'features/tenants/providers/tenants-provider/contexts/tenants-provider-context';

export type TenantsTableResult = {
  overflowMenuItems: Array<TableOverflowMenuItem<Tenant>>;
};

const useTenantsTable = (): TenantsTableResult => {
  const { t } = useTranslation('tenants');
  const { hasPermission } = usePermissionAuthorization();

  const { onAccessTenant, openDetails, allowOnAccessTenant } = use(TenantsProviderContext);

  const overflowMenuItems: Array<TableOverflowMenuItem<Tenant>> = [
    {
      label: t('tenantDetails.accessTenantButton'),
      action: (tenant) => onAccessTenant(tenant),
      isVisible: (tenant) => allowOnAccessTenant(tenant),
    },
    {
      label: t('tenantTable.action.view'),
      action: (tenant) => openDetails('viewing', tenant),
    },
    ...(hasPermission(Permission.UpdateTenant)
      ? [
          {
            label: t('tenantTable.action.edit'),
            action: (tenant: Tenant) => openDetails('editing', tenant),
          },
        ]
      : []),
  ];

  return {
    overflowMenuItems,
  };
};

export default useTenantsTable;
